// ('EVENT', { type: 'search', keyword: searchTerm });
export const track = (key, opts) => {
  if (typeof window !== 'undefined' && window.THD_EVENT_BUS) {
    window.THD_EVENT_BUS.trigger(`etch.${key}`, {
      ...opts,
      etchVersion: 2
    });
  }
};
